import { baseURL } from '../components/config';

export const URI = {
    login: `${baseURL}/api/auth/login`,
    register: `${baseURL}/api/auth/register`,
    user: `${baseURL}/api/user/user`,
    users: `${baseURL}/api/user/users`,
    assign_users: `${baseURL}/api/user/assign-users`,
    assigned_user: `${baseURL}/api/user/assigned-user`,
    assigned_users: `${baseURL}/api/user/assigned-users`,
    user_replacements: `${baseURL}/api/user/user-replacements`,
    user_replacement: `${baseURL}/api/user/user-replacement`,
    customer_replacements: `${baseURL}/api/user/customer-replacements`,
    assign_customer_replacements: `${baseURL}/api/user/assign-customer-replacements`,
    sales_reps: `${baseURL}/api/user/sales-reps`,
    assigned_customer: `${baseURL}/api/user/assigned-customer`,
    assigned_customers: `${baseURL}/api/user/assigned-customers`,
    customers: `${baseURL}/api/customer/customers`,
    customer_detail: `${baseURL}/api/customer/customer-detail`,
    customer_special_prices: `${baseURL}/api/customer/customer-special-prices`,
    sync_customer_prices: `${baseURL}/api/customer/sync-customer-prices`,
    customer_suggested_prices: `${baseURL}/api/customer/customer-suggested-prices`,
    customer_suggested_price_status: `${baseURL}/api/customer/customer-suggested-price-status`,
    customer_purchased_products: `${baseURL}/api/customer/customer-purchased-products`,
    customer_suggested_products: `${baseURL}/api/customer/customer-suggested-products`,
    customer_exclusion_product: `${baseURL}/api/customer/customer-product-exclusion`,
    customer_exclusion_products: `${baseURL}/api/customer/customer-product-exclusions`,
    customer_notes: `${baseURL}/api/customer/customer-notes`,
    validate_customer_special: `${baseURL}/api/customer/validate-customer-special`,
    customer_delivery_days: `${baseURL}/api/customer/customer-delivery-days`,
    customer_global: `${baseURL}/api/customer/customers-global`,
    call_list: `${baseURL}/api/customer/call-list`,
    call_list_log: `${baseURL}/api/customer/call-list-log`,
    call_list_logs: `${baseURL}/api/customer/call-list-logs`,
    call_list_by_customer: `${baseURL}/api/customer/call-list-by-customer`,
    sync_customers: `${baseURL}/api/customer/sync-customers`,
    check_customer_pending_prices: `${baseURL}/api/customer/check-customer-pending-prices`,
    customer_pending_prices: `${baseURL}/api/customer/customer-pending-prices`,
    products: `${baseURL}/api/product/products`,
    product: `${baseURL}/api/product/product`,
    product_quantities: `${baseURL}/api/product/product-quantities`,
    product_quantity: `${baseURL}/api/product/product-quantity`,
    recent_products: `${baseURL}/api/product/recent-products`,
    sync_products: `${baseURL}/api/product/sync-products`,
    favourite: `${baseURL}/api/product/favourite`,
    order: `${baseURL}/api/order/order`,
    ns_link: `${baseURL}/api/order/ns-link`,
    orders: `${baseURL}/api/order/orders`,
    order_item: `${baseURL}/api/order/item`,
    order_item_id: (id) => `${baseURL}/api/order/item/${id}`,
    open_order: `${baseURL}/api/order/open-order`,
    item_price: `${baseURL}/api/order/item-price`,
    post_orders: `${baseURL}/api/order/post-order`,
    promotion: `${baseURL}/api/promotion/promotion`,
    promotion_products: `${baseURL}/api/promotion/products`,
    promotions: `${baseURL}/api/promotion/promotions`,
    promotion_by_customer: `${baseURL}/api/promotion/customer`,
    post_promotion: `${baseURL}/api/promotion/post`,
    invoices: `${baseURL}/api/order/invoices`,
    invoice_note: `${baseURL}/api/order/invoice`,
    lead: `${baseURL}/api/lead/lead`,
    leads: `${baseURL}/api/lead/leads`,
    lead_status: `${baseURL}/api/lead/status`,
    lead_notes: `${baseURL}/api/lead/notes`,
    lead_suggested_products: `${baseURL}/api/lead/suggested-products`,
    lead_check_in: `${baseURL}/api/lead/check-in`,
    lead_routes: `${baseURL}/api/lead/routes`,
    lead_route: `${baseURL}/api/lead/route`,
    complete_route: `${baseURL}/api/lead/complete-route`,
    customer_statement: `${baseURL}/api/customer/ns-statement-link`,

    // Public APIs
    public_products: `${baseURL}/api/p/products`,
}